export default "__VITE_ASSET__4b2c8f44__"